export function getFcpMark(data: number): [string, string] {
  if (data === null) {
    return ["gray", "mdi-circle"];
  }
  if (data <= 1.8) {
    return ["#4CAF4F", "mdi-circle"];
  }
  if (data > 3.0) {
    return ["#ff6c6b", "mdi-triangle"];
  }
  return ["#ffba40", "mdi-square"];
}

export function getLcpMark(data: number): [string, string] {
  if (data === null) {
    return ["gray", "mdi-circle"];
  }
  if (data <= 2.5) {
    return ["#4CAF4F", "mdi-circle"];
  }
  if (data > 4.0) {
    return ["#ff6c6b", "mdi-triangle"];
  }
  return ["#ffba40", "mdi-square"];
}

export function getFidMark(data: number): [string, string] {
  if (data === null) {
    return ["gray", "mdi-circle"];
  }
  if (data <= 100) {
    return ["#4CAF4F", "mdi-circle"];
  }
  if (data > 300) {
    return ["#ff6c6b", "mdi-triangle"];
  }
  return ["#ffba40", "mdi-square"];
}

export function getClsMark(data: number): [string, string] {
  if (data === null) {
    return ["gray", "mdi-circle"];
  }
  if (data <= 0.1) {
    return ["#4CAF4F", "mdi-circle"];
  }
  if (data > 0.25) {
    return ["#ff6c6b", "mdi-triangle"];
  }
  return ["#ffba40", "mdi-square"];
}

export function getInpMark(data: number): [string, string] {
  if (data === null) {
    return ["gray", "mdi-circle"];
  }
  if (data <= 200) {
    return ["#4CAF4F", "mdi-circle"];
  }
  if (data > 500) {
    return ["#ff6c6b", "mdi-triangle"];
  }
  return ["#ffba40", "mdi-square"];
}

export function getTtfbMark(data: number): [string, string] {
  if (data === null) {
    return ["gray", "mdi-circle"];
  }
  if (data <= 0.8) {
    return ["#4CAF4F", "mdi-circle"];
  }
  if (data > 1.8) {
    return ["#ff6c6b", "mdi-triangle"];
  }
  return ["#ffba40", "mdi-square"];
}

export function getTtiMark(data: number): [string, string] {
  if (data === null) {
    return ["gray", "mdi-circle"];
  }
  if (data <= 3.8) {
    return ["#4CAF4F", "mdi-circle"];
  }
  if (data >= 7.3) {
    return ["#ff6c6b", "mdi-triangle"];
  }
  return ["#ffba40", "mdi-square"];
}
export function getTbtMark(data: number): [string, string] {
  if (data === null) {
    return ["gray", "mdi-circle"];
  }
  if (data <= 200) {
    return ["#4CAF4F", "mdi-circle"];
  }
  if (data >= 600) {
    return ["#ff6c6b", "mdi-triangle"];
  }
  return ["#ffba40", "mdi-square"];
}
export function getSiMark(data: number): [string, string] {
  if (data === null) {
    return ["gray", "mdi-circle"];
  }
  if (data <= 3.4) {
    return ["#4CAF4F", "mdi-circle"];
  }
  if (data >= 5.8) {
    return ["#ff6c6b", "mdi-triangle"];
  }
  return ["#ffba40", "mdi-square"];
}
export function getLabScoreColor(data: number): [string, string] | string {
  if (data >= 90) {
    return "#4CAF4F";
  }
  if (data <= 59) {
    return "#ff6c6b";
  }
  return ["#ffba40", "mdi-square"];
}
